import { createStore, combineReducers } from 'redux'
import { HistoryReducer } from 'Application/Store/Reducer/HistoryReducer'
import { ViewportReducer } from 'Application/Store/Reducer/ViewportReducer'
import { AnimationReducer } from 'Application/Store/Reducer/AnimationReducer'
import { LayoutReducer } from 'Application/Store/Reducer/LayoutReducer'
import { UserReducer } from 'Application/Store/Reducer/UserReducer'
import { ToothReducer } from 'Application/Store/Reducer/ToothReducer'
import { CollisionReducer } from './Reducer/CollisionReducer'

/*****************************************************************
 *  STORE
 * ***************************************************************/

const rootReducer = combineReducers({
    HistoryReducer,
    ViewportReducer,
    AnimationReducer,
    LayoutReducer,
    UserReducer,
    ToothReducer,
    CollisionReducer,
  })

/**
 * Provide Redux Store
 */
export const Store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
